import InventoryImagePlaceholder from './InventoryImagePlaceholder';
export default InventoryImagePlaceholder;